import { SettingsFields } from '../../components/form/GenericField';
import { ActivitySettings, ActivityTimeframes, AnalyticsSettings } from '@tradingblock/types';
import { useBlockId } from '../../components/blocks/BlockState';
import { useStateSelector } from '../../data/global/dataSelectors';
import { blockSettings } from '../../data/global/selectors/settingSelectors';
import _ from 'lodash';
import { ActivityTimeFrameSelector, TimeframePresetValues } from '../Activity/state/ActivitySelector';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { useActivityDataSelector } from '../Activity/state/ActivityState';

export const DefaultAnalyticBlockSettings: AnalyticsSettings = {
  timeframe: ActivityTimeframes.Week
};

export const AnalyticsSettingsFields: SettingsFields<AnalyticsSettings> = {
  timeframe: {
    type: 'choice',
    values: _.map(
      [
        ActivityTimeframes.Today,
        ActivityTimeframes.Week,
        ActivityTimeframes.Month,
        ActivityTimeframes.Year,
        ActivityTimeframes['Three Years'],
      ],
      tf => {
        return {
          value: tf,
          label: ActivityTimeframes[tf],
        };
      }
    ),
  },
};

export const useAnalyticsSettings = () => {
  const blockId = useBlockId();
  const current = useStateSelector(s => blockSettings.analytics(s, blockId));
  return {
    current: current,
    definitions: AnalyticsSettingsFields,
  };
};

export const useAnalyticsSettingsValue = (): AnalyticsSettings => {
  const { current } = useAnalyticsSettings();
  return current || { current: { timeframe: ActivityTimeframes.Week } };
};

export const useAnalyticsBlockData = () => {
  const blockId = useBlockId();
  const blockState = useStateSelector(s => s.account.ordersUIState[blockId]);
  if (!blockState) {
    return { pageSize: 50, pageIndex: 0, total: 0 };
  }
  return {
    pageSize: blockState.pageSize,
    pageIndex: blockState.pageIndex,
    total: blockState.total,
  };
};
